export const productosBalanzas = [
  {
    id: 101,
    categoria: 'balanzas',
    nombre: 'JADEVER JWL',
    descripcion: 'Balanza de sobremesa precisa, ideal para trabajos de laboratorio, comercio o industria ligera, ofreciendo pesaje confiable en un diseño práctico y resistente.',
    descripcion2: '',
    imagen: '/imagenes/productos/Balanzas/jwl1.webp',
    tablaEspecificaciones: {
      titulo: 'Especificaciones Técnicas - Serie JWL',
      columnas: ['Modelo', 'Jwl-6k', 'Jwl-7.5k', 'Jwl-15k', 'Jwl-30k'],
      filas: [
        {
          categoria: 'Capacidad (kg)',
          valores: ['6', '7.5', '15', '30']
        },
        {
          categoria: 'División (kg)',
          valores: ['0.5', '0.5', '1', '2']
        },
        {
          categoria: 'Unidades de pesaje',
          valores: ['KG, LB, G, PCS'],
          spanAll: true
        },
        {
          categoria: 'Monitor',
          valores: ['6 dígitos, 30mm Altura del dígito, pantalla LCD con LED verde Retroiluminación'],
          spanAll: true
        },
        {
          categoria: 'Peso Pan (MM)',
          valores: ['294 x 228 (acero inoxidable acero '],
          spanAll: true
        },
        {
          categoria: 'Dimensiones (mm)',
          valores: ['341 x 249 x 104'],
          spanAll: true
        },
        {
          categoria : 'Peso',
          valores: ['Peso neto 4.72kg; Peso bruto 5.11kg'],
          spanAll: true
        },
        {
          categoria: 'Fuente de Alimentación',
          valores: ['AC 110V / 220V (AC ± 10%) o recargable batería (6V / 4a)'],
          spanAll: true
        },
        {
          categoria: 'Certificación',
          valores: ['CE'],
          spanAll: true
        }
      ]
    },
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Balanza de mesa de alta resolución: hasta 1/15.000 d.',
          '•	Pantalla LCD grande con retroiluminación LED verde de alto brillo.',
          '•	Módulo A/D protegido por placa de aluminio para resguardar la PCB de ESD y humedad.',
          '•	Plato de pesaje de fácil desmontaje (acero inoxidable, diseño anti-insectos).',
          '•	Nivel de burbuja y patas nivelables.',
          '•	Protecciones mecánicas: contra sobrecarga y seguros de transporte.',
          '•	Autoapagado para ahorro de energía.',
          '•	Filtros digitales con niveles configurables.',

          
        ]
      },
      {
        titulo: 'Funciones de operación:',
        items: [
          '•	Cero, seguimiento de cero, tara, pesaje.',
          '•	Conteo de piezas (simple), acumulación.',
          '•	Chequeo de peso (HI/OK/LO).',
        ]
      }
    ],
    opciones: [
      {
        id: 'jwl-6kg',
        nombre: '6kg',
      },
      {
        id: 'jwl-7.5kg',
        nombre: '7.5kg',

      },
      {
        id: 'jwl-15kg',
        nombre: '15kg',

      },
      {
        id: 'jwl-30kg',
        nombre: '30kg',

      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/jwl1.webp',
      '/imagenes/productos/Balanzas/jwl2.webp',
      '/imagenes/productos/Balanzas/jwl3.webp',
    ]
  },
  {
    id: 118,
    categoria: 'balanzas',
    nombre: 'JADEVER JKH',
    descripcion: 'Balanza compacta Diseñada para ofrecer precisión y facilidad de uso en espacios reducidos. Su tamaño portátil y estructura resistente la hacen ideal',
    descripcion2: '',
    imagen: '/imagenes/productos/Balanzas/jkh1.webp',
    tablaEspecificaciones: {
      titulo: 'Especificaciones Técnicas - Serie JWL',
      columnas: ['Modelo', 'JKH-2000','JKH-4000k'],
      filas: [
        {
          categoria: 'Capacidad (G)',
          valores: ['2000', '4000']
        },
        {
          categoria: 'División (kg)',
          valores: ['0.5/0.1', '1/0.2']
        },
        {
          categoria: 'Unidades de pesaje',
          valores: ['G , OZ, CT, PCS'],
          spanAll: true
        },
        {
          categoria: 'Monitor',
          valores: ['5 dígitos, altura de dígitos de 14 mm, pantalla LCD retroiluminada verde'],
        },
        {
          categoria: 'Plato de pesaje (mm)',
          valores: ['140 x 140 (acero inoxidable)'],
          spanAll: true
        },
        {
          categoria: 'Dimensiones (mm)',
          valores: ['170 x 200 x 45'],
          spanAll: true
        },
        {
          categoria : 'Peso',
          valores: ['Peso neto 730g; Peso bruto1170g'],
          spanAll: true
        },
        {
          categoria: 'Fuente de Alimentación',
          valores: ['4 pilas secas AA o adaptador'],
          spanAll: true
        },
        {
          categoria: 'Certificación',
          valores: ['CE'],
          spanAll: true
        }
      ]
    },
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Tamaño compacto, fácil de llevar Balanza de balanza de conteo simple digital',
          '•	Resolución 1/5,000',
          '•	Luz de fondo LED retroiluminada de color verde brillante fácil de ver',
          '•	Bandeja de pesaje de acero inoxidable extraíble',
          '•	Cero / Tara / Pesaje / Peso neto / Peso bruto / Funciones de conteo simples.',
          '•	Apagado automático para ahorrar energía',

        ]
      },
      {
        titulo: 'Funciones de operación:',
        items: [
          '•	Cero, seguimiento de cero, tara, pesaje.',
          '•	Conteo de piezas (simple), acumulación.',
          '•	Chequeo de peso (HI/OK/LO).',
        ]
      }
    ],
    opciones: [
      {
        id: 'jkh-2000g',
        nombre: '2000g',
      },
      {
        id: 'jkh-4000g',
        nombre: '4000g',

      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/jkh1.webp',
      '/imagenes/productos/Balanzas/jkh2.webp',
      '/imagenes/productos/Balanzas/jkh3.webp',
    ]
  },
  {
    id: 102,
    categoria: 'balanzas',
    nombre: 'JADEVER JWE',
    descripcion: 'Balanza de mesa de alta precisión, múltiples unidades de pesaje, modelo versátil.',
    descripcion2: 'Balanza de mesa versátil con alta precisión y varias unidades de pesaje. Chasis robusto e indicador claro para uso continuo en entornos exigentes.',
    imagen: '/imagenes/productos/Balanzas/jwe1.webp',
    tablaEspecificaciones: {
      titulo: 'Especificaciones Técnicas - Serie JWE',
      columnas: ['Modelo', 'Jwe-3k', 'Jwe-6k', 'Jwe-15k', 'Jwe-30k'],
      filas: [
        {
          categoria: 'Capacidad (kg)',
          valores: ['3', '6', '15', '30']
        },
        {
          categoria: 'División (kg)',
          valores: ['0.1', '0.2', '0.5', '1']
        },
        {
          categoria :'Unidades de pesaje',
          valores: ['KG, G, T, OZ, PCS'],
          spanAll: true
        },
        {
          categoria: 'Monitor',
          valores: ['6 dígitos, 25mm Altura de dígitos, pantalla LCD con LED Retroiluminación.'],
          spanAll: true
        },

        {
          categoria: 'Peso Pan (MM)',
          valores: ['334 * 245 (Inoxidable Acero)'],
          spanAll: true
        },
        {
          categoria :'Peso',
          valores: ['Peso neto 1.15kg; Peso bruto 1.85kgpeso neto 4.72kg; bruto peso5.11kg'],
          spanAll: true
        },
        {
          categoria: 'Fuente de alimentación.',
          valores: ['AC 110V / 220V (AC ± 10%) o recargable batería (6V / 4a)'],
          spanAll: true
        },
        {
          categoria: 'Certificación',
          valores : ['CE'],
          spanAll: true
        }
      ]
    },
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Balanza de mesa digital de alta resolución (30 kg) con célula de carga True-Tec.',
          '•	Funciones de pesaje completas: cero, tara, pesaje normal, porcentaje, conteo de piezas (conteo simple), acumulación y chequeo de peso (checkweighing).',
          '•	Teclado de membrana sellado, duradero y resistente a salpicaduras.',
          '•	Plato de pesaje de acero inoxidable de gran tamaño, diseño anti-insectos.',
          '•	Módulo A/D protegido por placa de aluminio, que resguarda la PCB contra descargas electrostáticas (ESD) y humedad.',
          '•	Protecciones mecánicas contra sobrecarga y seguros de transporte.',
          '•	Filtros digitales por software con 2 niveles ajustables para estabilidad en distintas condiciones.',
          '•	Límites HI/LO/OK configurables y guardados en memoria.',
          '•	Interfaz RS-232  para conexión a PC o impresora.',
          '•	Alta precisión para farmacéutica, química, electrónica, producción de alimentos, metalurgia y otras aplicaciones exigentes.',

        ]
      },
    ],
    opciones: [
      {
        id: 'jwe-3kg',
        nombre: '3kg',
      },
      {
        id: 'jwe-6kg',
        nombre: '6kg',
      },
      {
        id: 'jwe-15kg',
        nombre: '15kg',
      },
      {
        id: 'jwe-30kg',
        nombre: '30kg',
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/jwe1.webp',
      '/imagenes/productos/Balanzas/jwe2.webp',
      '/imagenes/productos/Balanzas/jwe3.webp',
      '/imagenes/productos/Balanzas/jwe4.webp'
    ]
  },
  {
    id: 103,
    categoria: 'balanzas',
    nombre: 'JADEVER SNUG III',
    descripcion: 'Balanza económica con batería interna, fácil de usar, ideal para comercio general.',
    descripcion2: 'Modelo compacto y económico con batería interna y 13 unidades de pesaje, pensado para comercio y laboratorio liviano.',
    imagen: '/imagenes/productos/Balanzas/snug1.webp',
    tablaEspecificaciones: {
      titulo: 'Especificaciones Técnicas - Serie SNUG III',
      columnas: ['Modelo','SNUG III - 300', 'SNUG III - 1200', 'SNUG III - 3000'],
      filas: [
        {
          categoria: 'Capacidad (gr)',
          valores: ['300', '1200', '3000']
        },
        {
          categoria: 'División (gr)',
          valores: ['0,01/0,005', '0,05', '0,1/0,05']
        },
        {
          categoria :'Unidades de pesaje',
          valores: ['13 unidades de pesaje'],
          spanAll: true
        },
        {
          categoria: 'Monitor',
          valores: ['6 dígitos, 14mm altura de dígitos, Pantalla LCD con luz trasera LED verde'],
          spanAll: true
        },

        {
          categoria: 'Peso Pan (MM)',
          valores: ['146 × 125 (Inoxidable Acero)'],
          spanAll: true
        },
        {
          categoria: 'Dimensiones (mm)',
          valores: ['220x180x182'],
          spanAll: true

        },
        {
          categoria :'Peso',
          valores: ['Peso neto 1.15kg; Peso bruto 1.85kg'],
          spanAll: true
        },
        {
          categoria: 'Fuente de alimentación.',
          valores: ['Tamaño de 4 C Baterías o adaptadores secos'],
          spanAll: true
        },
        {
          categoria: 'Certificación',
          valores : ['CE'],
          spanAll: true
        }
      ]
    },
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Balanza de laboratorio de alta resolución (1/60.000 d).',
          '•	Pantalla LCD de alta visibilidad con retroiluminación LED verde.',
          '•	Escudo contra corrientes de aire (draft shield) para mejorar la estabilidad y exactitud del pesaje.',
          '•	Antiinterferencias y protección ESD para mayor fiabilidad electrónica.',
          '•	Protecciones mecánicas: dispositivos de sobrecarga y seguros de transporte.',
          '•	Funciones de operación completas: Cero, Tara, Pesaje, Conteo de piezas, Muestreo (definición de peso de muestra), Pesaje porcentual, RTC (reloj en tiempo real para fecha/hora) y Chequeo de peso (checkweighing).',
          '•	Autoapagado para ahorro de energía.',
          '•	Indicador de batería baja en la pantalla.',
          '•	Interfaz RS-232  para conexión a PC/impresora.',
          
        ]
      },
    ],
    opciones: [

      {
        id: 'snug-300',
        nombre: '300gr',
      },
      {
        id: 'snug-1200',
        nombre: '1200gr',
      },
      {
        id: 'snug-3000',
        nombre: '3000gr', 
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/snug1.webp',
      '/imagenes/productos/Balanzas/snug2.webp',
      '/imagenes/productos/Balanzas/snug3.webp',
    ]
  },    
  {
    id: 107,
    categoria: 'balanzas',
    nombre: 'JADEVER JCE',
    descripcion: 'Balanza económica con batería interna, fácil de usar, ideal para comercio general.',
    descripcion2: 'Balanza de mesa económica con pantalla LCD, multipropósito para comercio y producción ligera.',
    imagen: '/imagenes/productos/Balanzas/jce1.webp',
    tablaEspecificaciones: {
      titulo: 'Especificaciones Técnicas - JADEVER JCE',
      columnas: ['Modelo', 'JCE-6k','JCE-15k','JCE-30K',],
      filas: [

        {
          categoria: 'Capacidad (Kilogramos)',
          valores: ['6', '0.5', '30']
        },
        {
          categoria: 'División (gr)',
          valores: ['0.2/0,1', '0.5', '1']
        },
        {
          categoria :'Unidades de pesaje',
          valores: ['g/kg/libra'],
          spanAll: true
        },
        {
          categoria: 'Mostrar',
          valores: ['6/5/6 dígitos, 14mm altura de dígitos, Pantalla LCD retroiluminada'],
          spanAll: true
        },

        {
          categoria: 'Plato de pesaje(mm)',
          valores: ['334×245 (Inoxidable Acero)'],
          spanAll: true
        },
        {
          categoria: 'Dimensiones (mm)',
          valores: ['404×348×124'],
          spanAll: true

        },
        {
          categoria :'Peso',
          valores: ['Peso neto 5,99 kg; Peso bruto 6,7 kg'],
          spanAll: true
        },
        {
          categoria: 'Fuente de alimentación.',
          valores: ['CA 110 V/220 V (CA ± 10 %) o batería recargable (6 V/4 A)'],
          spanAll: true
        },
        {
          categoria: 'Certificación',
          valores : ['CE'],
          spanAll: true
        }
      ]
    },
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Balanza contadora digital de lectura rápida, resolución interna hasta 1/30.000 d.',
          '•	Teclado de membrana sellado, duradero y resistente al agua.',
          '•	Plato de acero inoxidable de gran tamaño, diseño anticucarachas.',
          '•	Filtros digitales con 2 niveles para mayor estabilidad de lectura.',
          '•	Protecciones mecánicas: sobrecarga y seguros de transporte.',
          '•	Software optimizado para operaciones de conteo flexibles.',
          '•	Límites HI/LO/OK configurables y almacenados en memoria, con alarma HI/LO/OK.',
          '•	Funciones: cero, tara, pre-tara, seguimiento de cero, acumulación (hasta 99 registros), autoapagado, cálculo automático del peso unitario (APW), conteo de piezas, muestreo por referencia y control por cantidad objetivo.',
          '•	Interfaz RS-232 (opcional) para conexión a PC/impresora.',
        
        ]
      },
    ],
    opciones: [
      {
        id: 'jce-6kg',
        nombre: '6kg',
      },
      {
        id: 'jce-15kg',
        nombre: '15kg',
      },
      {
        id: 'jce-30kg',
        nombre: '30kg',
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/jce1.webp',
      '/imagenes/productos/Balanzas/jce2.webp',
      '/imagenes/productos/Balanzas/jce3.webp',
    ]
  },
  {
    id: 104,
    categoria: 'balanzas',
    nombre: 'SUPER-SS',
    descripcion: 'Balanza de acero inoxidable, resistente, batería de larga duración, pesa en kg/lb.',
    descripcion2: 'Construcción en acero inoxidable con excelente autonomía. Ideal para ambientes exigentes; admite kg/lb y múltiples funciones.',
    imagen: '/imagenes/productos/Balanzas/supers1.webp',
    caracteristicas: [
      {
        titulo: 'Monitor y Pantalla',
        items: [
          '6 dígitos de visualización',
          '14mm altura de dígitos',
          'Pantalla LCD con luz trasera LED verde',
          '13 unidades de pesaje disponibles'
        ]
      },
      {
        titulo: 'Dimensiones y Peso',
        items: [
          'Peso Pan: 220x180x182mm',
          'Peso neto: 1.15kg',
          'Peso bruto: 1.85kg'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          'Tamaño de 4 C Baterías',
          'Adaptadores secos incluidos'
        ]
      },
      {
        titulo: 'Certificaciones',
        items: [
          'Certificación CE'
        ]
      }
    ],
    opciones: [
      {
        id: 'supers-6kg',
        nombre: '6kg',
      },
      {
        id: 'supers-15kg',
        nombre: '15kg',
      },
      {
        id: 'supers-30kg',
        nombre: '30kg',
      }
      ],
      imagenes: [
      '/imagenes/productos/Balanzas/supers1.webp',
      '/imagenes/productos/Balanzas/supers2.webp',
      '/imagenes/productos/Balanzas/supers3.webp',
    ]
  },
  {
    id: 119,
    categoria: 'balanzas',
    nombre: 'SHIMADZU MOC63U ANALIZADOR DE HUMEDAD (TERMOBALANZA)',
    descripcion: 'Analizador de humedad compacto y preciso que combina calentamiento halógeno de alta potencia con pesaje de alta resolución para obtener resultados rápidos y repetibles. ',
    descripcion2: 'Su bandeja amplia de Ø95 mm permite extender la muestra en capas finas, acelerando el secado y mejorando la exactitud. La operación es simple (teclado intuitivo e inicio automático al cerrar la tapa) y la memoria interna facilita estandarizar métodos y rastrear resultados.',
    imagen: '/imagenes/productos/Balanzas/shimadzumoc1.webp',
    caracteristicas: [
      {
        titulo: 'Características:',
        items: [
          ' •	Capacidad: 60 g',  
          '•	Lectura [d]: 0,001 g',
          '•	Reproducibilidad: 0,15% (2 g) – 0,05% (5 g) – 0,02% (10 g)',
          '•	Radiador halógeno de larga duración: mediciones rápidas y exactas.',
          '•	Rango de temperatura: 50–200 °C (configurable en pasos finos).',
          '•	Ventana de observación: permite ver la muestra durante el secado.',
          '•	Bandeja grande (Ø95 mm): mayor superficie → secado más uniforme y veloz.',
          '•	Operación sencilla: software claro, teclado simple y inicio automático (inicia la medición al cerrar la tapa).',
          '•	Memoria interna: hasta 10 condiciones de medición y 100 resultados almacenados.',
          '•	Conectividad: Puerto USB (requiere driver al conectar a PC).',
          '•	WindowsDirect: exporta datos a Excel/Windows sin software adicional, ideal para automatizar reportes y gráficos.',

        ]
      },
      {
        titulo: 'Modos de secado:',
        items: [
          '•	Rápido: arranca a temperatura máxima por un tiempo y luego baja a la temperatura objetivo (reduce el tiempo total).',
          '•	Lento: calentamiento suave para muestras que forman costra o se deterioran a alta temperatura.',
          '•	Por pasos: cambia condiciones paso a paso para materiales con alto contenido de agua.',

        ]
      },
      {
        titulo: 'Critecios de finalizacíon:',
        items: [
          '•	Automática (Auto-Stop): termina cuando la pérdida de humedad en los últimos 30 s es menor que el umbral definido.',
          '•	Programada por tiempo: finaliza cuando se cumple el tiempo establecido.',
          
        ]
      },

    ],
    opciones: [
      {
        id: 'shimadzu-moc63u',
        nombre: 'MOC63U',
        
      },
      
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/shimadzumoc1.webp',
      '/imagenes/productos/Balanzas/shimadzumoc2.webp',
      '/imagenes/productos/Balanzas/shimadzumoc3.webp',

    ]
  },
  {
    id: 105,
    categoria: 'balanzas',
    nombre: 'SHIMADZU TX 2202L',
    descripcion: 'Balanzas Diseñadas para laboratorios, industrias, farmacias y centros de investigación',
    descripcion2: 'Serie TX de Shimadzu para laboratorio: alta precisión, conectividad a PC y modos avanzados para formulación y conteo.',
    imagen: '/imagenes/productos/Balanzas/sshimadzu1.webp',
    caracteristicas: [
      {
        titulo: 'Especificaciones Técnicas',
        items: [
          'Capacidad: 2200 g',
          'Lectura [d]: 0,01 g',
          'Reproducibilidad: 0,01 g',
          'Linealidad: 0,02 g',
          'Platillo: 167 mm x 181 mm'
        ]
      },
      {
        titulo: 'Funcionalidades Avanzadas',
        items: [
          'Procedimientos de calibración',
          'Conexión directa con Windows',
          'Interface de conexión RS232C',
          'Modos de conteo de piezas y de formulación'
        ]
      },
      {
        titulo: 'Serie TX',
        items: [
          'Serie de balanzas analíticas de alta precisión',
          'Tecnología japonesa de vanguardia',
          'Ideal para aplicaciones de laboratorio e investigación'
        ]
      }
    ],
    opciones: [
      {
        id: 'shimadzu-tx2202l',
        nombre: 'TX 2202L',
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/sshimadzu1.webp',
      '/imagenes/productos/Balanzas/sshimadzu2.webp',
      '/imagenes/productos/Balanzas/sshimadzu3.webp',
    ]
  },

  {
    id: 106,
    categoria: 'balanzas',
    nombre: 'SHIMADZU AUW 220 D',
    descripcion: 'Las balanzas Shimadzu representan la excelencia en pesaje de alta precisión, con la confiabilidad y calidad',
    descripcion2: 'Semi micro de doble rango con calibración automática y reportes GLP/GMP/ISO. Ideal para investigación y control de calidad.',
    imagen: '/imagenes/productos/Balanzas/sshiamdzu220i1.webp',
    caracteristicas: [
      {
        titulo: 'Especificaciones Técnicas',
        items: [
          'Rango dual',
          'Capacidad: 220 g / 82 g',
          'Lectura [d]: 0,1 mg / 0,01 mg',
          'Reproducibilidad: 0,1 mg / 0,05 mg',
          'Linealidad: 0,2 mg / 0,1 mg',
          'Platillo: ∅ 80 mm',
          'P/N: 321-62900-32'
        ]
      },
      {
        titulo: 'Funcionalidades Avanzadas',
        items: [
          'Calibración automática',
          'Reportes de calibración GLP/GMP/ISO',
          'Conexión directa con Windows',
          'Modos de conteo de piezas y de formulación',
          'Gancho inferior de pesaje'
        ]
      },
      {
        titulo: 'Serie AUW',
        items: [
          'Serie de balanzas semi micro de alta precisión',
          'Tecnología japonesa de vanguardia',
          'Ideal para aplicaciones de laboratorio e investigación'
        ]
      }
    ],
    opciones: [
      {
        id: 'shimadzu-auw220d',
        nombre: 'AUW 220 D',
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/sshiamdzu220i1.webp',
      '/imagenes/productos/Balanzas/sshiamdzu220i2.webp',

    ]
  },

  {
    id: 108,
    categoria: 'balanzas',
    nombre: 'TOMS TM-EXJ2204H',
    descripcion: 'La TOMS TM-EXJ2204H es una balanza analítica económica y confiable para laboratorios, control de calidad y educación.',
    descripcion2: 'Ofrece capacidad de 220 g y resolución de 0,0001 g (0,1 mg), con lectura clara en pantalla LCD retroiluminada y calibración externa mediante pesa patrón. Incluye función para medición de densidad de sólidos y líquidos, interfaz RS-232C para conexión a PC y cumplimiento ISO 9001.',
    imagen: '/imagenes/productos/Balanzas/toms1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Capacidad / Resolución: 220 g / 0,0001 g (0,1 mg)',
          '•	Repetibilidad (σ): ±0,0003 g',
          '•	Linealidad: ±0,0003 g',
          '•	Plato de pesaje: acero inoxidable Ø 90 mm',
          '•	Display: LCD con retroiluminación (alta legibilidad)',
          '•	Calibración: externa (con pesa patrón)',
          '•	Unidades: g, ct ',
          '•	Interfaz: RS-232C (para registro y trazabilidad de datos)',
          '•	Alimentación: adaptador de CA',
          '•	Temperatura de operación: 15–35 °C',
          '•	Estructura: carcasa plástica',
          '•	Funciones: medición de densidad de líquidos y sólidos',
          '•	Dimensiones : 325 × 205 × 305 mm',
          '•	Peso neto: 8 kg',

        ]
      }
    ],
    opciones: [
      {
        id: 'toms-exj2204h',
        nombre: 'TM-EXJ2204H',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/toms1.webp',


    ]
  },
  {
    id: 109,
    categoria: 'balanzas',
    nombre: 'TOMS TM-EXA',
    descripcion: 'La TOMS TM-EXA ofrece una combinación equilibrada de precisión y costo para laboratorios, control de calidad y educación.',
    descripcion2: 'Con capacidad de 300 g y 100g  y resolución de 0,001 g (1 mg), integra pantalla LCD retroiluminada de alta legibilidad, calibración externa con pesa patrón, interfaz RS-232C para registro de datos y función para medición de densidad de líquidos y sólidos. Cumple ISO 9001.',
    imagen: '/imagenes/productos/Balanzas/tmex1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Capacidad / Resolución: 300 g, 100 g / 0,001 g (1 mg)',
          '•	Repetibilidad (σ): ±0,002 g',
          '•	Linealidad: ±0,002 g',
          '•	Plato de pesaje: acero inoxidable Ø 118 mm',
          '•	Display: LCD retroiluminada (alta legibilidad; altura de dígitos ~15–22 mm según versión)',
          '•	Calibración: externa (con pesa patrón)',
          '•	Unidades: g, ct ',
          '•	Interfaz: RS-232C',
          '•	Alimentación: adaptador de CA',
          '•	Temperatura de operación: 15–35 °C',
          '•	Estructura exterior: carcasa plástica',
          '•	Funciones: medición de densidad de líquidos y sólidos',
          '•	Peso neto: 3,2 kg',
          
        ]
      },
      {
        titulo: 'Modelos:',
        items: [
          '•	TM-EXA1003H: 100 g × 0,001 g',
          '•	TM-EXA3003H: 300 g × 0,001 g',
        ]
      }
    ],
    opciones: [
      {
        id: 'toms-exa1003h',
        nombre: 'TM-EXA1003H',
      },
      {
        id: 'toms-exa3003h',
        nombre: 'TM-EXA3003H',
      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/tmex1.webp',


    ]
  },
  {
    id: 110,
    categoria: 'balanzas',
    nombre: 'TOMS TM-EXB',
    descripcion: 'Balanza de precisión con cámara antiviento, pantalla LED de 22 mm con retroiluminación',
    descripcion2: 'Balanza de precisión con cámara antiviento, pantalla LED de 22 mm con retroiluminación, funciones completas de operación y salida RS-232C para conexión a PC/impresora. Ideal para laboratorios, control de calidad y producción. Calibración externa mediante pesa patrón.',
    imagen: '/imagenes/productos/Balanzas/texb1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Capacidad / Resolución: 1500g / 0,01 g ',
          '•	Display: LED de alta visibilidad (altura de dígitos 22,0 mm) con backlight',
          '•	Funciones: Tara, Cero, Calibración externa, Cambio de unidades (seleccionables), Conteo de piezas, Envío de datos/impresión.',
          '•	Interfaz: RS-232C estándar (para pantalla externa, computador o impresora).',
          '•	Plato de pesaje: acero inoxidable 145 × 115 × 70 mm.',
          '•	Cámara antiviento (carcasa plástica): 185 × 150 × 112 mm.',
          '•	Alimentación: 110–220 V mediante adaptador de CA.',

        ]
      }
    ],
    opciones: [
      {
        id: 'texb-1500g',
        nombre: 'TM-EXB1502S',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/texb1.webp',


    ]
  },
  {
    id: 111,
    categoria: 'balanzas',
    nombre: 'TOMS TM- EXC',
    descripcion: 'Serie económica de precisión 0,01 g con pantalla LCD retroiluminada (22 mm), calibración externa y salida RS-232C. Diseñada para laboratorio, control de calidad y uso industrial. Disponible con versión certificada por metrología legal ',
    descripcion2: 'Serie económica de precisión 0,01 g con pantalla LCD retroiluminada (22 mm), calibración externa y salida RS-232C. Diseñada para laboratorio, control de calidad y uso industrial. Disponible con versión certificada por metrología legal ',
    imagen: '/imagenes/productos/Balanzas/texc1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Resolución: 0,01 g (10 mg)',
          '•	Repetibilidad (σ): hasta ±0,03 g ',
          '•	Linealidad: hasta ±0,03 g ',
          '•	Plato de pesaje: acero inoxidable 188 × 148 mm',
          '•	Display: LCD retroiluminada, altura de dígitos 22 mm, alta legibilidad',
          '•	Calibración: externa (pesa patrón)',
          '•	Unidades: g, ct ',
          '•	Interfaz: RS-232C (PC/impresora)',
          '•	Alimentación: Adaptador de CA',
          '•	Temperatura de operación: 15–35 °C',
          '•	Estructura exterior: carcasa plástica',
          '•	Funciones: medición de densidad de líquidos y sólidos',
          '•	Peso neto: 1,2 kg',
          
        ]
      },
      {
        titulo: 'Modelos:',
        items: [
          '•	TM-EXC30002: 3000 g × 0,01 g',
          '•	TM-EXC50002: 5000 g × 0,01 g',
        ]
      }
    ],
    opciones: [
      {
        id: 'texc-30002',
        nombre: 'TM-EXC30002',
      },
      {
        id: 'texc-50002',
        nombre: 'TM-EXC50002',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/texc1.webp',


    ]
  },
  {
    id: 112,
    categoria: 'balanzas',
    nombre: 'TOMS TM- STC',
    descripcion: 'Báscula económica de 0,1 g de resolución, pensada para laboratorio, control de calidad y producción. La TM-STC60001 ofrece capacidad de 6.000 g, calibración externa con pesa patrón, pantalla LCD retroiluminada (22 mm) y salida RS-232C para conexión a PC/impresora.',
    descripcion2: '',
    imagen: '/imagenes/productos/Balanzas/testc1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Capacidad / Resolución: 6.000 g / 0,1 g (100 mg)',
          '•	Repetibilidad (σ): ±0,02 g',
          '•	Linealidad: ±0,02 g',
          '•	Plato de pesaje: acero inoxidable 188 × 148 mm',
          '•	Display: LCD retroiluminada, altura de dígitos 22 mm',
          '•	Calibración: externa (External Calibration)',
          '•	Unidades: g, ct ',
          '•	Interfaz: RS-232C (PC/impresora)',
          '•	Alimentación: Adaptador de CA',
          '•	Temperatura de operación: 15–35 °C',
          '•	Estructura exterior: carcasa plástica',
          '•	Funciones: medición de densidad de líquidos y sólidos',
          '•	Peso neto: 1,2 kg',
          
        ]
      }
    ],
    opciones: [
      {
        id: 'toms-stc',
        nombre: 'TOMS TM- STC',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/testc1.webp',

    ]
  },
  {
    id: 113,
    categoria: 'balanzas',
    nombre: 'TOMS TM-EXG',
    descripcion: 'Plataforma de acero inoxidable SUS304 (330 × 260 mm), indicador ABS, LCD retroiluminada 22 mm, RS-232C, calibración externa, alimentación CA/Batería',
    descripcion2: '',
    imagen: '/imagenes/productos/Balanzas/texg1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Unidades: g',
          '•	Plataforma de pesaje: 330 × 260 mm',
          '•	Interfaz: RS-232C (PC/impresora)',
          '•	Temperatura de operación: 15–35 °C',
          '•	Estructura: Indicador ABS + plataforma/base SUS304',
          '•	Pantalla: LCD con retroiluminación (22 mm)',
          
        ]
      },
      {
        titulo: 'Modelos:',
        items: [
          '•	EXG150005: 15 kg × 0,05 g',
          '•	EXG300001: 30 kg × 0,1 g',
        ]
      }
    ],
    opciones: [
      {
        id: 'texg-150005',
        nombre: 'EXG150005',
        
      },
      {
        id: 'texg-300001',
        nombre: 'EXG300001',
        
      }
    ],
    imagenes: [
      '/imagenes/productos/Balanzas/texg1.webp',

    ]
  },
]; 